import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../../enum/enum";
import { useLoader } from "../../../context/loaderContext";
import { useAuth } from "../../../context/authContext";
import Layout from "../../../layout/layout";
import moment from "moment";

const SelfBusiness = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const [selfBusiness, setSelfBusiness] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const getSelfBusiness = async () => {
        try {
            const url = `${BaseUrl}Dashboard/SelfBusiness`;

            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "userID": userId,
                    "version": Version
                },
                "request": {
                    "isSeller": false,
                    "loginTypeID": 0
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setSelfBusiness(res.data.data || []);
            } else {
                setSelfBusiness([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    const getProcessedDash = (totalDays, remainingDays) => {
        const remainingPercent = (remainingDays / totalDays) * 100;

        const radius = 33;
        const circumference = 2 * Math.PI * radius;

        const visible = (circumference * remainingPercent) / 100;

        // IMPORTANT: return string
        return `${visible} ${circumference}`;
    };


    useEffect(() => {
        getSelfBusiness();
        setFromDate(moment(new Date()).format(("YYYY-MM-DD")));
        setToDate(moment(new Date()).format(("YYYY-MM-DD")));
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Self Business </h5>
                                    </div>
                                    {/* filters */}
                                    {/* {selfBusiness?.length > 0 && ( */}
                                    {/* <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >
                                        <div>
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                min={fromDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div> 
                                        <div className="d-flex-end">
                                            <button
                                                type="button"
                                                onClick={getSelfBusiness}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div> */}
                                    {/* // )} */}
                                    {/* records */}
                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            selfBusiness?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Currency</th>
                                                                <th scope="col">Amount</th>
                                                                <th scope="col">Business Type</th>
                                                                <th scope="col">Package Name</th>
                                                                <th scope="col">Activation Date</th>
                                                                <th scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                selfBusiness?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{el.businessCurrency}</td>
                                                                        <td>${el.packageCost}</td>
                                                                        <td>{el.businessType}</td>
                                                                        <td>{el.packageName}</td>
                                                                        <td>{el.businessDate}</td>
                                                                        <td className="py-1">
                                                                            {
                                                                                el.packageID == 9 ? (
                                                                                    <div class="cus-progress-div">
                                                                                        <svg class="progress-circle" width="77px" height="77px" xmlns="http://www.w3.org/2000/svg">
                                                                                            <circle class="progress-circle-back"
                                                                                                cx="38" cy="38" r="33"></circle>
                                                                                            <circle class="progress-circle-prog"
                                                                                                cx="38" cy="38" r="33"
                                                                                                // style={{
                                                                                                //     strokeDasharray: 
                                                                                                // }}
                                                                                                strokeDasharray={getProcessedDash(el.totalROIDays, el.remainingROIDays)}
                                                                                            ></circle>
                                                                                        </svg>
                                                                                        <div class="progress-text">
                                                                                            {el.remainingROIDays}
                                                                                            <div className="small-text">days</div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : null
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {selfBusiness?.length > 0 ? (
                                            selfBusiness.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.businessDate}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Currency:</strong>
                                                        <p className="mb-0 f-w-500">{el.businessCurrency}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Amount:</strong>
                                                        <p className="mb-0 f-w-500">${el.packageCost}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Business Type:</strong>
                                                        <p className="mb-0 f-w-500">{el.businessType}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Package Name:</strong>
                                                        <p className="mb-0 f-w-500">{el.packageName}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <strong> </strong>
                                                        {
                                                            el.packageID == 9 ? (
                                                                <div style={{ margin: "-3px -8px -5px 0px" }}>
                                                                    <div class="cus-progress-div">
                                                                        <svg class="progress-circle" width="77px" height="77px" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle class="progress-circle-back"
                                                                                cx="38" cy="38" r="33"></circle>
                                                                            <circle class="progress-circle-prog"
                                                                                cx="38" cy="38" r="33"
                                                                                strokeDasharray={getProcessedDash(el.totalROIDays, el.remainingROIDays)}
                                                                            ></circle>
                                                                        </svg>
                                                                        <div class="progress-text">
                                                                            {el.remainingROIDays}
                                                                            <div className="small-text">days</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default SelfBusiness;